// removed by extract-text-webpack-plugin
module.exports = {"income-expense-chart":"income-expense-chart","chart-container":"chart-container","chart-content":"chart-content","visible":"visible","chart-error":"chart-error"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/dashboard/component/income-expense-chart/income-expense-chart.style.sass
// module id = u60v
// module chunks = 0